import { Card } from '@ovotech/nebula';
import styled from 'styled-components';
import { mqMediumUp } from '@/src/utils/mediaQuery';

export const DesktopContainer = styled(Card)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 0;
`;

export const VolvoMobileContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  img {
    border-radius: 4px;
    width: 260px;
  }
`;

export const VolvoLeftContent = styled.div`
  display: none;
  margin: 0;
  padding: 0;
  position: relative;
  img {
    width: 150px;
  }
  ${mqMediumUp(`
    img {
      width: 240px;
    }
    width: 33%;
    display: inline-block;
  `)}
`;

export const VolvoRightContent = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  ${mqMediumUp(`
    width: 66%;
  `)}
`;
